export default __webpack_public_path__ + "static/media/NeonGenesis.8a2a5824.webp";